import { render, staticRenderFns } from "./legal_male.vue?vue&type=template&id=457ccad1&scoped=true&"
var script = {}
import style0 from "./legal_male.vue?vue&type=style&index=0&id=457ccad1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457ccad1",
  null
  
)

export default component.exports